// extracted by mini-css-extract-plugin
export default {"wrapper":"w0-z","play":"x0-z"};